module.exports = __webpack_public_path__ + "img/aabe1beddf22b4a98261263b4a03bbac.jpg";